export const calculateHeaderSize = () => {
    const messages = document.querySelector('.js-header-messages')
    const header = document.querySelector('.l-header')
    let combinedHeight = 0;

    if (!header && !messages) {
        return
    }

    if (header) {
        combinedHeight += header.offsetHeight;
    }

    if (messages) {
        combinedHeight += messages.offsetHeight;
    }

    document.documentElement.style.setProperty('--header-height', `${combinedHeight}px`)
}